module.exports = __webpack_public_path__ + "img/date.47a11f2d.svg";